export default __webpack_public_path__ + "static/media/bgBlue120x176.426d0131.jpg";